import { Injectable } from '@angular/core';
import { Action, Selector, SelectorOptions, State, StateContext } from '@ngxs/store';

import { FlowSplit } from '@pe/checkout/types';


import {
  SetSplits,
} from './split.actions';

export interface SplitStateModel {
  payments: FlowSplit[];
}

const initialState: SplitStateModel = {
  payments: [],
};

@State<SplitStateModel>({
  name: 'split',
  defaults: initialState,
})
@SelectorOptions({
  injectContainerState: false,
  suppressErrors: false,
})
@Injectable()
export class SplitState {


  @Selector() static splits(state: SplitStateModel): FlowSplit[] {
    return state.payments;
  }

  @Action(SetSplits)
  setSplits(
    { patchState }: StateContext<SplitStateModel>,
    action: SetSplits,
  ) {
    patchState({
      payments: action.payload,
    });
  }
}
